import SmallLogoFooter from '@gameday/common/components/form/Common/SmallLogoFooter'
import ButtonWithLink from '@gameday/react-components/components/ButtonWithLink'
import Paper from '@gameday/react-components/components/Paper'
import STGTermsAndConditions from '@gameday/react-components/components/STGTermsAndConditions'
import theme, { rem } from '@gameday/react-components/utils/theme'
import { get } from 'lodash'
import { connect } from 'react-redux'
import styled from 'styled-components'

import routes from '../../../../constants/routes/routes'

const StyledPageWrap = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: center;
  width: 100%;

  .MuiPaper-root {
    padding: 42px 34px;
    background: ${theme.colors.white};
    ${theme.breakpoints.down(400)} {
      padding: 30px 20px;
    }
  }
  > div:first-of-type {
    min-height: 0;
    padding: 60px 30px 30px 30px;
  }
`

const StyledTitle = styled.h1`
  color: ${theme.body.headingColor};
  font-size: ${rem(20)};
  font-weight: 600;
  text-align: center;
`

const StyledText = styled.p`
  color: ${theme.body.headingColor};
  text-align: center;
  font-size: ${rem(14)};
  font-weight: 400;
  line-height: ${rem(21)};
`

const StyledCopyrightText = styled(STGTermsAndConditions)`
  font-size: ${rem(12)};
`

const StyledSpan = styled.span`
  font-weight: 600;
`

const StyledLogo = styled.img`
  width: ${rem(168)};
  height: ${rem(168)};
  margin-bottom: ${rem(10)};
  object-fit: cover;
`

const StyledButtonWithLink = styled(ButtonWithLink)`
  margin-top: 30px;
  margin-bottom: 35px;
`

const SignUpSuccessPage = props => {
  const { user, logo, history } = props

  const { email } = user
  return (
    <StyledPageWrap>
      <Paper>
        {logo && <StyledLogo src={logo} alt="logo" />}
        <StyledTitle>Verify Your Account</StyledTitle>
        <StyledText>
          We&apos;ve sent you an email to
          <StyledSpan>{` ${email || ''}`}</StyledSpan>
          <br />
          Please check your email and click the link in that message to verify your account
        </StyledText>
        <StyledButtonWithLink
          variant="contained"
          fullWidth
          disableRipple
          type="submit"
          label="Back to login"
          color="primary"
          onClick={() =>
            history.push({
              pathname: routes.login.path,
              search: history.location.search,
            })
          }
        />
        <StyledCopyrightText showSignUp />
      </Paper>
      <SmallLogoFooter />
    </StyledPageWrap>
  )
}

const mapStateToProps = state => ({
  user: get(state, 'auth.user'),
  logo: get(state, 'formSettings.eventLogo'),
})

export default connect(mapStateToProps)(SignUpSuccessPage)
